import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfigurationService } from '../../common';
import { PagedDataRequest } from '../models/paged-data-request';
import { PagedDataResponse } from '../models/paged-data-response';

@Injectable({
  providedIn: 'root'
})
export class ApiClientService {
  private apiUrl: string;

  constructor(appConfig: AppConfigurationService,
    private httpClient: HttpClient) {
      this.apiUrl = this.appendTrailingSlash(appConfig.getValue('apiUrl'));
  }

  public get<T>(
    url: string,
    options?: {
        headers?: HttpHeaders | {
            [header: string]: string | string[];
        };
        observe?: 'body';
        params?: HttpParams | {
            [param: string]: string | string[];
        };
        reportProgress?: boolean;
        responseType?: 'json';
        withCredentials?: boolean;
    }): Observable<T> {
    return this.httpClient.get<T>(this.makeAbsoluteUrl(url), options);
  }

  public getPagedData<T>(
    url: string,
    pagedDataRequest: PagedDataRequest,
    options?: {
        headers?: HttpHeaders | {
            [header: string]: string | string[];
        };
        observe?: 'body';
        params?: HttpParams | {
            [param: string]: string | string[];
        };
        reportProgress?: boolean;
        responseType?: 'json';
        withCredentials?: boolean;
    }): Observable<PagedDataResponse<T>> {

    if (!options) {
      options = {};
    }

    options.params = Object.assign({}, options.params, pagedDataRequest);

    return this.httpClient.get<PagedDataResponse<T>>(this.makeAbsoluteUrl(url), options);
  }

  public put<T>(
    url: string,
    body: any | null,
    options?: {
      headers?: HttpHeaders | {
          [header: string]: string | string[];
      };
      observe?: 'body';
      params?: HttpParams | {
          [param: string]: string | string[];
      };
      reportProgress?: boolean;
      responseType?: 'json';
      withCredentials?: boolean;
    }) {
    return this.httpClient.put<T>(this.makeAbsoluteUrl(url), body, options);
  }

  public post<T>(
    url: string, body: any | null,
    options?: {
      headers?: HttpHeaders | {
          [header: string]: string | string[];
      };
      observe?: 'body';
      params?: HttpParams | {
          [param: string]: string | string[];
      };
      reportProgress?: boolean;
      responseType?: 'json';
      withCredentials?: boolean;
    }) {
    return this.httpClient.post<T>(this.makeAbsoluteUrl(url), body, options);
  }

  public delete<T>(
    url: string, options?: {
    headers?: HttpHeaders | {
        [header: string]: string | string[];
    };
    observe?: 'body';
    params?: HttpParams | {
        [param: string]: string | string[];
    };
    reportProgress?: boolean;
    responseType?: 'json';
    withCredentials?: boolean;
    }) {
    return this.httpClient.delete<T>(this.makeAbsoluteUrl(url), options);
  }

  private makeAbsoluteUrl(relativeUrl: string) {
    relativeUrl = this.removeLeadingSlash(relativeUrl);

    return `${this.apiUrl}${relativeUrl}`;
  }

  private appendTrailingSlash(url: string) {
    if (url.endsWith('/')) {
      return url;
    }

    return `${url}/`;
  }

  private removeLeadingSlash(url: string) {
    if (!url.startsWith('/')) {
      return url;
    }

    return url.substring(1, url.length);
  }
}
